<template>
  <div
    v-if="!loading"
    class="contentContainer grow"
    style="margin-bottom: 16px"
  >
    <h1>
      {{ $t("bnpl:customer_limit.questions.title") }}
    </h1>

    <CustomerLastNameField
      field-id="lastName"
      :required="true"
      :check-validity="false"
    />

    <CustomerFirstNameField
      field-id="firstName"
      :required="true"
      :check-validity="false"
    />

    <CustomerBirthDateField
      field-id="birthDate"
      :required="true"
      :check-validity="false"
    />

    <CustomerPostCodeField
      field-id="postCode"
      :required="true"
      :check-validity="false"
    />
  </div>
</template>

<script setup>
import { useProfileStore } from "~~/stores/profile";

const profileStore = useProfileStore();

const loading = ref(true);

onBeforeMount(async () => {
  await profileStore.fetch();
  loading.value = false;
});
</script>

<style scoped lang="scss"></style>
